/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-statements */
import React, { useEffect, useRef, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { FaImages, FaShare, FaUser } from 'react-icons/fa';
import {
	QueryClient,
	QueryClientProvider,
	useMutation,
	useQuery
} from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { globalEnv } from '../../../config/baseConfig';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { hideSearchbarAction } from '../../../redux/actions/searchBarAction';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import Editable from '../../Utils/editable';
import { DataNotFoundAnimation } from '../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../Utils/LoadingAnimations/loadingAnimation';
import LoadingRectanglesAnimation from '../../Utils/LoadingAnimations/LoadingRectanglesAnimation';
import { stateNotificationsEnum } from '../../Utils/notification';
import Pagination from '../../Utils/Pagination';
// import AddImageModal from './AddImageModal';
import meavanaLogo from '../../../assets/images/MeaVanaLogo.png';
import StyleModalContent from './TopicStyling/styleModal';
import {
	BasicTopicStyle,
	TopicStyles
} from './TopicStyling/StyleComponents/mixins/mixins';
import SaveButton from '../../Utils/saveButton';
import axiosInstance from '../../../config/axiosInstance';
import { Tag } from './tag';
import { BackgroundImage } from './imageComponents/imageComponent';
import RemoveModal from '../../Utils/Components/modals/removeModal';
import LazyImage from '../../Utils/Components/lazyImageComponent';
import ParentModal from '../../Utils/Components/modals/parentModal';
import AddContributors, { ContribModal } from './addContributors';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { SetUnsavedChangesAction } from '../../../redux/actions/globalAction';
import { Switch } from '@headlessui/react';
import { checkTopicName, verifTitle } from '../../Utils/helpers';
import { BsExclamationCircleFill } from 'react-icons/bs';
import { ClockTypes } from './TopicStyling/StyleComponents/mixins/optionsValues';
import { useDebounce, useDebouncedCallback } from 'use-debounce';
import { AddMediaModalContent } from './imageComponents/addMultipleImagesModalContent';
import { VideoComponent } from './imageComponents/videoComponent';

const queryClient = new QueryClient();

export default function Topic() {
	const dispatch = useDispatch();
	dispatch(setSelectedSection('Topic Details'));
	dispatch(setTab('documents'));
	dispatch(hideSearchbarAction());
	return (
		<QueryClientProvider client={queryClient}>
			<div className="h-full w-full pt-16">
				<TopicDetails />
			</div>
		</QueryClientProvider>
	);
}

export enum MediaType {
	IMAGES = 'images',
	PHONE_IMAGES = 'phoneImages',
	VIDEOS = 'videos',
	PHONE_VIDEOS = 'phoneVideos'
}

function TopicDetails() {
	const [topicId, setId] = useState('');
	const [name, setName] = useState('');
	const [originalName, setOriginalName] = useState('');
	const [titleErrorMsg, setTitleErrorMsg] = useState({
		message: '',
		error: false
	});

	const [mediaType, setMediaType] = useState(MediaType.IMAGES);

	const [code, setCode] = useState('');
	const [status, setStatus] = useState('Rejected');
	const [tags, setTags] = useState<string[]>([]);
	const [dailyImage, setDailyImage] = useState('');
	const [description, setDescription] = useState('');
	const [usersCount, setUsersCount] = useState(0);
	const [activeUsersCount, setActiveUsersCount] = useState(0);
	const [reloadCount, setReloadCount] = useState(0);
	const [creator, setCreator] = useState<any>({
		_id: '0',
		username: 'Meavana'
	});
	const [contributors, setContributors] = useState<any>([
		{
			_id: '0',
			username: 'Meavana'
		}
	]);

	const [isSearchingConributors, setIsSearchingConributors] = useState(false);
	const [isMine, setIsMine] = useState(false);
	const [isCollaborator, setIsCollaborator] = useState(false);
	const [isShowingPhoneImgs, setIsShowingPhoneImgs] = useState(false);

	const nameRef = useRef<null>(null);
	const descriptionRef = useRef<null>(null);

	const [searchParams, setSearchParams] = useSearchParams();
	const urlPage = searchParams.get('page');
	const [page, setPage] = useState(
		urlPage != null && !isNaN(parseInt(urlPage)) ? parseInt(urlPage) : 1
	);

	const [media, setMedia] = useState<any[]>([]);
	const [mediaCount, setMediaCount] = useState(0);

	const [isContribModalChanged, setIsContribModalChanged] = useState(false);

	const [isAddMultipleImagesModalOpen, setAddMultipleImagesModalOpen] =
		useState(false);
	const [isAddMultipleImagesModalChanged, setAddMultipleImagesModalChanged] =
		useState(false);

	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);

	const [isFirstTime, setIsFirstTime] = useState(true);

	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [isPrivate, setIsPrivate] = useState(false);
	const [coverPic, setCoverPic] = useState<string>('');

	const [style, setStyle] = useState<TopicStyles>(BasicTopicStyle);
	const [isStyleModalOpen, setIsStyleModalOpen] = useState(false);

	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

	const { id } = useParams();

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	const debounced = useDebouncedCallback((value) => {
		setIsChanged(true);
		checkTopicName({
			topicName: value,
			setTitleErrorMsg: setTitleErrorMsg
		});
	}, 1000);

	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (page != null) {
			if (page === 1) {
				searchParams.delete('page');
				setSearchParams(searchParams);
			} else history.pushState(history.state, 'topic', `?page=${page}`);
		}
	}, [page]);

	useEffect(() => {
		dispatch(
			SetUnsavedChangesAction({
				unsavedChanges: isChanged
			})
		);
	}, [isChanged]);

	const dispatch = useDispatch();

	const { data, isFetching, isLoading, isError } = useQuery(
		['topics', topicId, page, mediaType, reloadCount],
		() => fetchTopicDetails(id!, page, ACCESS_TOKEN),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	// Prefetch the next page!
	useEffect(() => {
		if (data == null) return;
		if (page < data.meta.limit) {
			queryClient.prefetchQuery(['topics', page + 1], () =>
				fetchTopicDetails(id!, page + 1, ACCESS_TOKEN)
			);
		}
	}, [data, page, mediaType, queryClient]);

	async function fetchTopicDetails(
		id: string,
		page: number,
		accessToken: string
	) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		};

		const { data } = await axiosInstance().get(
			`${globalEnv.BASE_URL}/topic/${id}/get-detailed?page=${page}&mediaType=${mediaType}`,
			config
		);
		return data;
	}

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const { user }: any = useTypedSelector((state) => state.auth);

	const navigate = useNavigate();

	useEffect(() => {
		if (data != null) {
			if (isFirstTime) {
				setName(data.data[0].name);
				setOriginalName(data.data[0].name);
				setDescription(data.data[0].description);
				setCode(data.data[0].code);
				setStatus(data.data[0].reviewStatus);
				if (data.data[0].creator.length > 0) {
					setCreator(data.data[0].creator[0]);
					if (user._id === data.data[0].creator[0]._id) setIsMine(true);
				}
				if (data.data[0].contributors.length > 0) {
					if (
						data.data[0].contributors
							.map((contributor: any) => contributor._id)
							.includes(user._id)
					) {
						setIsMine(true);
						setIsCollaborator(true);
					}
				}

				if (data.data[0].newStyle != null) {
					let clock;
					try {
						if (data.data[0].newStyle.clock.kind === ClockTypes.Analog)
							clock = {
								kind: data.data[0].newStyle.clock.kind,
								showSeconds: data.data[0].newStyle.clock.showSeconds,
								size: data.data[0].newStyle.clock.size,
								isDark: data.data[0].newStyle.clock.isDark,
								isNumbered: data.data[0].newStyle.clock.isNumbered
							};
						else if (data.data[0].newStyle.clock.kind === ClockTypes.Digital)
							clock = {
								kind: data.data[0].newStyle.clock.kind,
								showSeconds: data.data[0].newStyle.clock.showSeconds,
								size: data.data[0].newStyle.clock.size,
								boldness: data.data[0].newStyle.clock.boldness,
								showAmPm: data.data[0].newStyle.clock.showAmPm,
								showTwentyFour: data.data[0].newStyle.clock.showTwentyFour
							};
						else
							clock = {
								kind: data.data[0].newStyle.clock.kind,
								size: data.data[0].newStyle.clock.size,
								boldness: data.data[0].newStyle.clock.boldness
							};
					} catch (e) {
						clock = BasicTopicStyle.clock;
					}

					try {
						let defaultBookmarkList;
						if (data.data[0].defaultBookmarkList != null)
							defaultBookmarkList = data.data[0].defaultBookmarkList;
						else defaultBookmarkList = BasicTopicStyle.defaultBookmarkList;

						setStyle({
							appearanceStyle: {
								font: data.data[0].newStyle.appearanceStyle.font,
								mode: data.data[0].newStyle.appearanceStyle.mode,
								opacity: data.data[0].newStyle.appearanceStyle.opacity,
								view: data.data[0].newStyle.appearanceStyle.view
							},
							quoteStyle: {
								size: data.data[0].newStyle.quoteStyle.size,
								useCustomQuote: data.data[0].newStyle.quoteStyle.useCustomQuote,
								customQuote:
									data.data[0].newStyle.quoteStyle.customQuote != null
										? data.data[0].newStyle.quoteStyle.customQuote
										: null
							},
							sidebarStyle: {
								contentWidth: data.data[0].newStyle.sidebarStyle.contentWidth,
								width: data.data[0].newStyle.sidebarStyle.width,
								view: data.data[0].newStyle.sidebarStyle.view
							},
							wallpaperStyle: {
								background: data.data[0].newStyle.wallpaperStyle.background,
								blur: data.data[0].newStyle.wallpaperStyle.blur,
								brightness: data.data[0].newStyle.wallpaperStyle.brightness
							},
							searchbarOptions: data.data[0].newStyle.searchbarOptions,
							searchEngines: data.data[0].newStyle.searchEngines,
							focusStyle:
								data.data[0].newStyle.focusStyle != null
									? {
											myFocus: data.data[0].newStyle.focusStyle.myFocus,
											size: data.data[0].newStyle.focusStyle.size
									  }
									: BasicTopicStyle.focusStyle,
							greetingStyle:
								data.data[0].newStyle.greetingStyle != null
									? { size: data.data[0].newStyle.greetingStyle.size }
									: BasicTopicStyle.greetingStyle,
							clock: clock,
							featuresStyle: {
								time: data.data[0].newStyle.featuresStyle.time,
								date: data.data[0].newStyle.featuresStyle.date,
								weather: data.data[0].newStyle.featuresStyle.weather,
								bookmarks: data.data[0].newStyle.featuresStyle.bookmarks,
								notes: data.data[0].newStyle.featuresStyle.notes,
								quote: data.data[0].newStyle.featuresStyle.quote,
								integrations: data.data[0].newStyle.featuresStyle.integrations,
								searchBar: data.data[0].newStyle.featuresStyle.searchBar
							},
							integrationsStyle: data.data[0].newStyle.integrationsStyle,
							bookmarkStyle: {
								selectedBookmarks:
									data.data[0].newStyle.bookmarkStyle.selectedBookmarks,
								blackAndWhite:
									data.data[0].newStyle.bookmarkStyle.blackAndWhite,
								openNewTab: data.data[0].newStyle.bookmarkStyle.openNewTab,
								square: data.data[0].newStyle.bookmarkStyle.square,
								gap: data.data[0].newStyle.bookmarkStyle.gap,
								size: data.data[0].newStyle.bookmarkStyle.size
							},
							defaultBookmarkList: defaultBookmarkList
						});
					} catch (e) {
						console.log(e);
					}
				}

				if (data.data[0].tags != null) setTags(data.data[0].tags);
				setIsPrivate(data.data[0].isPrivate);
				setIsFirstTime(false);
				setId(data.data[0]._id);
			}
			setUsersCount(data.data[0].usersCount);
			setActiveUsersCount(data.data[0].activeUsersCount);
			setContributors(data.data[0].contributors);
			if (data.data[0].dailyImage != null)
				setDailyImage(data.data[0].dailyImage.url);
			setMedia(data.data[0].media);
			if (data.meta.total != null) setMediaCount(data.meta.total);
			if (data.data[0].coverPic) setCoverPic(data.data[0].coverPic.url);
		}
	}, [data]);

	const ReviewStatusMessage = ({
		text,
		offset = '160'
	}: {
		text: string;
		offset: string;
	}) => {
		return (
			<span
				className={`absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
										  scale-0 origin-top group-hover:scale-100 z-50 font-bold transition-all 
										  duration-500 opacity-0 group-hover:opacity-100 ml-2 top-16 ${offset}`}
			>
				{text}
			</span>
		);
	};

	const OptionButtons = () => {
		return (
			<div className="flex flex-row  dark:bg-gray-700 bg-gray-100">
				{isMine && (
					<>
						<div className="relative group">
							<button
								type="button"
								className="btn btn-outline btn-sm btn-primary mr-2"
								onClick={() => setIsStyleModalOpen(true)}
							>
								Stylize
							</button>

							<span
								className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
										  scale-0 origin-top group-hover:scale-100 z-50 font-bold transition-all 
										  duration-500 opacity-0 group-hover:opacity-100 top-10 -right-32"
							>
								{
									'Change the theme of your topic (Clock style, Bookmakrs, etc..)'
								}
							</span>
						</div>
					</>
				)}

				<div className="relative group">
					<button
						type="button"
						className="btn btn-outline btn-sm btn-primary mr-1"
						onClick={() => {
							navigator.clipboard.writeText(
								`https://meavana.com/?topic=${code}`
							);

							dispatch(
								SetNotificationAction({
									type: stateNotificationsEnum.SUCCESS,
									message: 'Topic URL copied to clipboard.'
								})
							);
						}}
					>
						<FaShare size={16} />
					</button>

					<span
						className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs z-20
									  scale-0 origin-top group-hover:scale-100
						              font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-10 left-[50%] translate-x-[-50%]"
					>
						{"Copy topic's url"}
					</span>
				</div>
			</div>
		);
	};

	const GeneralData = () => {
		return (
			<div className="flex md:py-4 lg:pt-3">
				<div className="relative group md:p-2 text-center dark:bg-gray-700 bg-gray-100 rounded-xl mr-2">
					<FaUser size={16} className="mt-1.5 mb-0.5  dark:text-white mx-2" />
					<span className="text-sm font-bold block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500">
						{usersCount}
					</span>

					<span
						className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
															scale-0 origin-top group-hover:scale-100 z-50 font-bold transition-all 
															duration-500 opacity-0 group-hover:opacity-100 top-16 -left-8"
					>
						{'Subscribed users'}
					</span>
				</div>

				<div className="relative md:p-2 group text-center  dark:bg-gray-700 bg-gray-100 rounded-xl mr-2">
					<FaUser size={16} className="mt-1.5 mb-0.5  text-green-600 mx-2" />
					<span className="text-sm font-bold block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500">
						{activeUsersCount}
					</span>

					<span
						className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
															scale-0 origin-top group-hover:scale-100 z-50 font-bold transition-all 
															duration-500 opacity-0 group-hover:opacity-100 top-16 -left-28"
					>
						{'Active users that are currently using the topic'}
					</span>
				</div>
				<div className="md:p-2 text-center dark:bg-gray-700 bg-gray-100 rounded-xl">
					<FaImages size={19} className="mt-1 dark:text-white mx-1.5" />
					<span className="text-sm font-bold block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500">
						{mediaCount}
					</span>
				</div>
				{isMine && (
					<div className="relative p-2 text-center dark:bg-gray-700 bg-gray-100 rounded-xl ml-2 group">
						<span
							className="text-xs font-semibold block uppercase tracking-wide text-gray-600 
									dark:text-white transition-all duration-500 mt-1 mb-0.5"
						>
							Status
						</span>
						<span
							className={`text-xs font-bold block uppercase tracking-wide transition-all duration-500 ${
								status === 'accepted'
									? 'text-green-600'
									: status === 'featured'
									? 'text-purple-600'
									: status === 'pending' || status == null
									? 'text-yellow-600'
									: status === 'additional review'
									? 'text-blue-500'
									: 'text-red-600'
							}`}
						>
							{status === 'accepted'
								? 'Accepted'
								: status === 'featured'
								? 'Featured'
								: status === 'pending' ||
								  status === 'additional review' ||
								  status == null
								? 'Reviewing'
								: 'Rejected'}
						</span>

						<ReviewStatusMessage
							text={
								status === 'accepted'
									? 'Your topic has been accepted, it is available on Meavana'
									: status === 'featured'
									? 'Your topic is featured on Meavana.'
									: status === 'pending' || status == null
									? "Your topic is being reviewed, once accepted it'll be shown on Meavana."
									: status === 'additional review'
									? 'Your topic is being reviewed, once accepted the updates will be shown on Meavana.'
									: "Your topic has been rejected and won't be shown on Meavana."
							}
							offset={
								status === 'accepted'
									? '-right-32'
									: status === 'featured'
									? '-right-[69px]'
									: status === 'pending' || status == null
									? '-right-[168px]'
									: status === 'additional review'
									? '-right-52'
									: '-right-36'
							}
						/>
					</div>
				)}
			</div>
		);
	};

	const saveTopicReq = async () => {
		const dto = {
			topicId: topicId,
			name: name,
			description: description,
			code: code,
			tags: tags,
			newStyle: style,
			isPrivate: isPrivate,
			defaultBookmarkList: style.defaultBookmarkList,
			contributors: contributors.map((item: any) => item._id)
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + '/editor/topic/update',
			dto,
			config
		);
		return response;
	};

	const deleteTopicReq = async () => {
		const { data: response } = await axiosInstance().delete(
			globalEnv.BASE_URL + '/editor/topic/delete',
			{
				data: {
					topicId: topicId
				},
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return response;
	};

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	const saveTopic = useMutation(saveTopicReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated topic info.'
				})
			);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	const deleteTopic = useMutation(deleteTopicReq, {
		onSuccess: () => {
			navigate('../user/' + user._id);
		},

		onError: (error) => {
			console.log(error);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't delete topic."
				})
			);
		}
	});

	function addTag() {
		setTags([...tags, '']);
	}

	const contribSearchRef = useRef(null) as any;

	return (
		<Scrollbars autoHide>
			{isLoading ? (
				<LoadingAnimComponent />
			) : isError ? (
				<div className="h-full ml-16 ">
					<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
						<div className="mx-auto my-auto self-center">
							<div className="min-h-16">
								<DataNotFoundAnimation height={dimensions.height / 1.5} />
							</div>
							<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
								{"Couldn't find the data you're looking for!"}
							</h3>
						</div>
					</div>
				</div>
			) : (
				<main>
					<ParentModal
						visible={isStyleModalOpen}
						setModalOpen={setIsStyleModalOpen}
						isChanged={isChanged}
						setIsChanged={setIsChanged}
						isWarnModalOpen={isWarnModalOpen}
						setIsWarnModalOpen={setIsWarnModalOpen}
					>
						<StyleModalContent
							style={style}
							setStyle={setStyle}
							setModalOpen={setIsStyleModalOpen}
							setIsChanged={setIsChanged}
							isChanged={isChanged}
							isWarnModalOpen={isWarnModalOpen}
							setIsWarnModalOpen={setIsWarnModalOpen}
						/>
					</ParentModal>
					<section className="relative block" style={{ height: '500px' }}>
						<div
							className="absolute top-0 w-full h-full bg-center bg-cover"
							style={{
								backgroundImage: `url('${coverPic ? coverPic : dailyImage}')`
							}}
						>
							<span
								id="blackOverlay"
								className="w-full h-full absolute opacity-50 bg-black"
							></span>

							<div
								className="absolute ml-8 top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2' z-10 w-full min-h-[28px]
										md:w-8/12 order-1 md:order-2 lg:w-10/12 md:px-6 text-center self-center"
							>
								{isMine || isCollaborator ? (
									<div className="pb-3 mt-[4px] sm:mt-[8px] md:mt-[10px] xl:mt-[16px] flex flex-row justify-center">
										<Editable
											text={name}
											placeholder="Topic name"
											childRef={nameRef}
											type="input"
											className="text-4xl sm:text-5xl md:text-6xl xl:text-8xl font-semibold order-1"
											textColor={` transition-colors duration-500 drop-shadow-lg ${
												titleErrorMsg.error
													? 'text-red-800'
													: 'text-primary-text-dark'
											}`}
										>
											<input
												ref={nameRef}
												type="text"
												name="name"
												className="rounded text-4xl sm:text-5xl md:text-6xl xl:text-8xl font-semibold leading-snug text-center 
													bg-transparent backdrop-blur-lg transition-all duration-500 text-primary-text-dark pb-3 w-11/12"
												placeholder=""
												onBlur={() => {
													verifTitle(name, setTitleErrorMsg);
												}}
												value={name}
												onChange={(e) => {
													setTitleErrorMsg({
														error: false,
														message: ''
													});
													setName(e.target.value);
													debounced(e.target.value);
												}}
											/>
										</Editable>
										{titleErrorMsg.error && (
											<div className="relative group">
												<button className="absolute top-2 left-2 btn-error btn-md btn btn-circle btn-outline shadow-md">
													<BsExclamationCircleFill size={20} />
												</button>
												<span
													className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
												scale-0 origin-left group-hover:scale-100
												font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-4 mb-0.5 left-16"
												>
													{titleErrorMsg.message}
												</span>
											</div>
										)}
									</div>
								) : (
									<span className="text-6xl font-semibold leading-snug pb-3 dark:text-primary-text-dark text-primary-text-light transition-colors duration-500">
										{name}
									</span>
								)}
							</div>
						</div>
					</section>
					<section className="relative py-16 bg-gray-400 dark:bg-zinc-800 transition-all duration-500 pl-16">
						<div className="container mx-auto px-4">
							<div
								className="relative flex flex-col min-w-0 break-words bg-base-bg-light dark:bg-base-bg-dark
											transition-all duration-500 w-full shadow-xl rounded-2xl -mt-64"
							>
								<div className="px-6">
									<div className="flex flex-col md:flex-row justify-between mx-auto  rounded-xl w-full lg:w-10/12 transition-all duration-500">
										<div className="md:w-2/12 mb-2 md:mb-0 md:order-1 order-2 lg:w-3/12 xl:w-2/12 self-center">
											<GeneralData />
										</div>

										<div className="relative md:w-8/12 order-1 md:order-2 lg:w-8/12 mt-4 xl:mt-0 mb-3 xl:mb-0">
											<div
												className="xl:absolute dark:bg-gray-700 bg-gray-100 rounded-xl w-fit mx-auto lg:-mt-1
												xl:ml-8 xl:top-1/2 xl:left-1/2 xl:transform xl:-translate-x-1/2 xl:-translate-y-1/2 px-2 py-1"
											>
												<span className="text-xs font-bold text-center block uppercase tracking-wide text-gray-600 dark:text-white transition-all duration-500 mt-0.5 mb-1">
													Created by
												</span>
												<div className="relative flex flex-row justify-center">
													<LazyImage
														photo={
															data.data[0].creator.length > 0
																? creator.photo != null
																	? creator.photo
																	: `https://api.dicebear.com/7.x/bottts/svg?seed=${creator.username}`
																: meavanaLogo
														}
														dimesnions={{ width: '28', height: '28' }}
														loaderDimesnions={10}
													/>
													<span className="font-bold text-sm lg:text-base dark:text-gray-100 ml-2">
														{creator.username}
													</span>
												</div>
											</div>
										</div>

										<div className="order-3 md:w-2/12 lg:w-3/12 mb-3 md:mb-0 self-center h-14 flex flex-row justify-end">
											{isMine && (
												<div className="relative group px-4 pb-2 xl:mr-4 mr-2 dark:bg-gray-700 bg-gray-100 rounded-xl">
													<span className=" text-sm font-medium text-gray-900 dark:text-gray-400">
														{'Set to private'}
													</span>
													<div className="mt-0.5 w-full px-6">
														<Switch
															checked={isPrivate}
															onChange={() => setIsPrivate(!isPrivate)}
															className={`${
																isPrivate ? 'bg-purple-600' : 'bg-gray-600'
															} relative inline-flex h-6 w-11 items-center rounded-full`}
														>
															<span
																className={`${
																	isPrivate ? 'translate-x-6' : 'translate-x-1'
																} inline-block h-4 w-4 transform rounded-full bg-gray-200 transition-all ease-in-out duration-200`}
															/>
														</Switch>
													</div>

													<span
														className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
															scale-0 origin-top group-hover:scale-100 z-50 font-bold transition-all 
															duration-500 opacity-0 group-hover:opacity-100 top-14 -right-24"
													>
														{
															"If set to private, the topic won't be shown to anyone"
														}
													</span>
												</div>
											)}

											<div className="relative px-4 py-3 dark:bg-gray-700 bg-gray-100 rounded-xl ">
												<OptionButtons />
											</div>
										</div>
									</div>

									<div className="mx-auto border-t w-10/12 mb-3 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

									<div
										className="flex flex-row w-full lg:w-10/12 md:w-11/12 mt-5 mb-2 mx-auto 
												  sm:px-2 md:px-10 lg:px-6 lg:mt-3 lg:mb-0"
									>
										<div
											className={`${
												isMine ? 'lg:w-7/12 ml-auto' : 'lg:w-full mr-auto'
											}`}
										>
											<h3 className="font-bold mb-2 text-sm lg:text-base dark:text-gray-100">
												Tags
											</h3>
											<div className="flex flex-row space-x-2">
												{tags != null &&
													tags.map((tag, index) => (
														<Tag
															name={tag}
															isMine={isMine}
															setIsChanged={setIsChanged}
															index={index}
															setTags={setTags}
															tags={tags}
														/>
													))}

												{tags != null ? (
													tags.length > 0 ? (
														isMine && (
															<div
																className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
															>
																<span
																	className="text-xs font-bold mx-1"
																	onClick={addTag}
																>
																	➕
																</span>
															</div>
														)
													) : (
														<div className="inline-block">
															<span className="text-xs font-bold mx-1 dark:text-gray-400 text-gray-600">
																This topic has no Tags
															</span>
															{isMine && (
																<div
																	className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
																>
																	<span
																		className="text-xs font-bold mx-1"
																		onClick={addTag}
																	>
																		Create Topic's first Tag➕
																	</span>
																</div>
															)}
														</div>
													)
												) : (
													<div className="inline-block">
														<span className="text-xs font-bold mx-1 text-gray-400">
															This topic has no Tags
														</span>
														{isMine && (
															<div
																className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
															>
																<span
																	className="text-xs font-bold mx-1"
																	onClick={addTag}
																>
																	Create Topic's first Tag➕
																</span>
															</div>
														)}
													</div>
												)}
											</div>
										</div>
										{isMine && (
											<div className="relative lg:w-5/12 flex">
												<div
													className={`flex flex-row ml-auto mt-1.5 ${
														isSearchingConributors && 'z-30'
													}`}
													ref={contribSearchRef}
												>
													{contributors.map((contributor: any) => (
														<div
															className="relative group mr-1 mt-0.5 cursor-pointer"
															onClick={(e) => {
																if (isSearchingConributors) {
																	const contributorsCopy = contributors.slice();
																	const updatedContributorsList =
																		contributorsCopy.filter((item: any) => {
																			return contributor._id !== item._id;
																		});
																	setContributors(updatedContributorsList);
																} else if (contributors.length > 0) {
																	e.stopPropagation();
																	navigate(`../user/${contributor._id}`);
																}
															}}
														>
															<LazyImage
																photo={
																	contributor.photo != null
																		? contributor.photo
																		: `https://api.dicebear.com/7.x/bottts/svg?seed=${contributor.username}`
																}
																dimesnions={{ width: '27', height: '27' }}
																loaderDimesnions={27}
															/>

															{isSearchingConributors ? (
																<span
																	className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
																	scale-0 origin-top group-hover:scale-100 z-30
																	font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 -top-10 -right-10"
																>
																	{'Click to remove'}
																</span>
															) : (
																<span
																	className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
															scale-0 origin-top group-hover:scale-100 z-30
															font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 
															top-[100%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
																>
																	{contributor.username}
																</span>
															)}
														</div>
													))}
													<div className="relative group ">
														<button
															key={'add-contrib-btn'}
															className="btn btn-outline rounded-full btn-sm btn-primary ml-1 z-30"
															onClick={() => {
																setIsSearchingConributors(
																	!isSearchingConributors
																);
															}}
															ref={contribSearchRef}
														>
															<AiOutlineUserAdd size={20} />
														</button>
														{isSearchingConributors || (
															<span
																className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
																	scale-0 origin-top group-hover:scale-100 z-50
																	font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-10 -right-36"
															>
																{
																	'Edit your contributors list to help manage your topic 🙋'
																}
															</span>
														)}
													</div>
												</div>
												<ContribModal
													visible={isSearchingConributors}
													setModalOpen={setIsSearchingConributors}
													isChanged={isContribModalChanged}
													setIsChanged={setIsContribModalChanged}
													isWarnModalOpen={isWarnModalOpen}
													setIsWarnModalOpen={setIsWarnModalOpen}
												/>
												{isSearchingConributors && (
													<div className="absolute mt-12 right-0 z-30">
														<AddContributors
															buttonRef={contribSearchRef}
															isModalOpen={isSearchingConributors}
															setIsModalOpen={setIsSearchingConributors}
															contributors={contributors}
															setContributors={setContributors}
															setIsChanged={setIsChanged}
														/>
													</div>
												)}
											</div>
										)}
									</div>
									<div className="text-center">
										<div className="text-gray-500 font-bold mx-auto">
											{isMine ? (
												<div className="leading-normal mt-5 mb-2 text-gray-500 dark:text-white text-left w-full lg:w-10/12 md:w-11/12 mx-auto sm:px-2 md:px-10 lg:px-4 lg:mt-3 lg:mb-0">
													<i className="fas fa-map-marker-alt mr-2 text-sm text-gray-500" />
													<label className="text-lg lg:text-xl font-semibold dark:text-white text-gray-600">
														Description:
													</label>
													<Editable
														text={description}
														placeholder="No description is provided"
														childRef={descriptionRef}
														type="textarea"
														className="font-semibold leading-normal w-full p-2 ml-0.5"
														textColor="text-gray-700 dark:text-gray-100"
													>
														<textarea
															ref={descriptionRef}
															name="name"
															className="text-gray-700 dark:text-gray-100 font-semibold leading-normal 
																w-full p-2 dark:bg-gray-800  ml-0.5"
															placeholder=""
															value={description}
															onChange={(e) => {
																setDescription(e.target.value);
																setIsChanged(true);
															}}
														/>
													</Editable>
												</div>
											) : description === '' ? (
												<></>
											) : (
												<div
													className="leading-normal mt-5 mb-2 text-gray-500 dark:text-white text-left w-10/12
																mx-auto sm:px-2 md:px-10 lg:px-6 lg:mt-3 lg:mb-0"
												>
													<i className="fas fa-map-marker-alt mr-2 text-sm text-gray-500" />
													<label className="text-lg lg:text-xl font-semibold dark:text-white text-gray-600">
														Description:
													</label>
													<span
														className="text-gray-700 dark:text-gray-100 font-semibold leading-normal 
																w-full p-2 dark:bg-gray-800 text-lg"
													>
														{description}
													</span>
												</div>
											)}
										</div>
										<div className=" mx-auto border-t w-10/12 mt-5 invisible text-center" />

										<div className="w-10/12 h-12 flex flex-row mb-4 mx-auto">
											<button
												type="button"
												className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
															 border-gray-200  hover:text-purple-700 dark:text-gray-400
															  dark:border-gray-600 dark:hover:text-white "
												onClick={() => {
													setMediaType(MediaType.IMAGES);
													setPage(1);
												}}
											>
												<div
													className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.IMAGES && 'opacity-80'}`}
												/>
												Desktop Images
											</button>

											<button
												type="button"
												className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
												 border-l border-gray-200  hover:text-purple-700 dark:text-gray-400
												dark:border-gray-600 dark:hover:text-white "
												onClick={() => {
													setMediaType(MediaType.PHONE_IMAGES);
													setPage(1);
												}}
											>
												<div
													className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.PHONE_IMAGES && 'opacity-80'}`}
												/>
												Phone Images
											</button>

											<button
												type="button"
												className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
												 border-l border-gray-200  hover:text-purple-700 dark:text-gray-400
												dark:border-gray-600 dark:hover:text-white "
												onClick={() => {
													setMediaType(MediaType.VIDEOS);
													setPage(1);
												}}
											>
												<div
													className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.VIDEOS && 'opacity-80'}`}
												/>
												Videos
											</button>

											<button
												type="button"
												className="relative w-full py-2.5 px-5 mb-2 text-sm font-medium text-gray-900
													border-l border-gray-200  hover:text-purple-700 dark:text-gray-400
												  dark:border-gray-600 dark:hover:text-white "
												onClick={() => {
													setMediaType(MediaType.PHONE_VIDEOS);
													setPage(1);
												}}
											>
												<div
													className={`absolute inset-0 pb-1 bg-gradient-to-b dark:from-gray-600/50 from-gray-400/50 opacity-0
													hover:opacity-100 transition-all duration-500 text-center
													${mediaType === MediaType.PHONE_VIDEOS && 'opacity-80'}`}
												/>
												Phone Videos
											</button>
										</div>

										<div className="container sm:px-2 md:px-20 mx-auto lg:px-32 text-center mb-4">
											<div className="flex flex-row justify-between mb-3">
												<div className="flex flex-1 ">
													{isMine && (
														<div className="inline-flex">
															<button
																className="btn btn-outline btn-sm btn-primary ml-auto mt-1.5 mr-0"
																onClick={() => {
																	navigate(`reorder-images`);
																}}
															>
																Edit images layout
															</button>
														</div>
													)}
												</div>
												<h3 className="mt-1 lg:mt-0 xl:flex-1 text-2xl lg:text-4xl font-semibold text-gray-600 dark:text-gray-500">
													{/* IMAGES */}
												</h3>

												<ParentModal
													visible={isAddMultipleImagesModalOpen}
													setModalOpen={setAddMultipleImagesModalOpen}
													isChanged={isAddMultipleImagesModalChanged}
													setIsChanged={setAddMultipleImagesModalChanged}
													isWarnModalOpen={isWarnModalOpen}
													setIsWarnModalOpen={setIsWarnModalOpen}
												>
													<AddMediaModalContent
														setModalOpen={setAddMultipleImagesModalOpen}
														topicId={topicId}
														topicName={name}
														isChanged={isAddMultipleImagesModalChanged}
														setIsChanged={setAddMultipleImagesModalChanged}
														setIsWarnModalOpen={setIsWarnModalOpen}
														media={media}
														setMedia={setMedia}
														mediaCount={mediaCount}
														mediaType={mediaType}
														setMediaCount={setMediaCount}
													/>
												</ParentModal>

												<div className="flex flex-1 justify-end">
													{isMine && (
														<div className="flex flex-1 justify-end">
															<div className="inline-flex">
																<div className={`relative`}>
																	<button
																		className={`relative btn btn-outline btn-sm mt-1.5 mr-0 ml-2 min-w-200 btn-primary`}
																		onClick={() => {
																			setAddMultipleImagesModalOpen(true);
																		}}
																	>
																		{mediaType === MediaType.IMAGES ||
																		mediaType === MediaType.PHONE_IMAGES
																			? 'Add Images ➕'
																			: 'Add Videos ➕'}
																	</button>
																</div>
															</div>
														</div>
													)}
												</div>
											</div>
											{isFetching || isLoading ? (
												<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 justify-items-center gap-4">
													<LoadingRectanglesAnimation />
												</div>
											) : isError ? (
												<></>
											) : (
												<div className="flex flex-wrap -m-1 md:-m-2">
													{mediaType === MediaType.IMAGES ||
													mediaType === MediaType.PHONE_IMAGES
														? media.map((item: any) => (
																<BackgroundImage
																	key={item._id}
																	item={item}
																	isMine={isMine}
																	topicId={topicId}
																	images={media}
																	setImages={setMedia}
																	reloadCount={reloadCount}
																	setReloadCount={setReloadCount}
																	isForPhone={
																		mediaType === MediaType.PHONE_IMAGES
																	}
																	setCoverPic={setCoverPic}
																	isCollaborator={isCollaborator}
																/>
														  ))
														: media.map((item: any) => (
																<VideoComponent
																	key={item._id}
																	item={item}
																	isMine={isMine}
																	topicId={topicId}
																	videos={media}
																	setVideos={setMedia}
																	reloadCount={reloadCount}
																	setReloadCount={setReloadCount}
																	isForPhone={
																		mediaType === MediaType.PHONE_VIDEOS
																	}
																	setIsChanged={setIsChanged}
																/>
														  ))}
												</div>
											)}
										</div>
										{isFetching || isLoading || isError ? (
											<></>
										) : media.length > 0 ? (
											<Pagination
												itemsPerPage={data.meta.limit}
												totalCount={data.meta.total}
												totalPages={data.meta.pages}
												currentPage={page}
												setPage={setPage}
											/>
										) : (
											<div>
												<h3 className="dark: text-white font-semibold text-4xl my-32">
													No results were found.
												</h3>
											</div>
										)}
									</div>
								</div>
								<div className="w-full px-4">
									{isMine && !isCollaborator ? (
										<div className="py-6 px-3 flex flex-row">
											<div>
												<RemoveModal
													title={'Remove Topic'}
													text={'Are you sure you want to remove this topic?'}
													setModalOpen={setIsRemoveModalOpen}
													setAction={() => deleteTopic.mutate()}
													visible={isRemoveModalOpen}
												/>
											</div>
											<div className="justify-start flex-1">
												<button
													className="btn btn-outline btn-sm btn-error mr-1"
													type="button"
													style={{ transition: 'all .15s ease' }}
													onClick={(e) => {
														e.stopPropagation();
														setIsRemoveModalOpen(true);
													}}
												>
													Delete
												</button>
											</div>
											<div className="justify-end">
												<button
													className="btn btn-outline btn-sm mr-1 "
													type="button"
													style={{ transition: 'all .15s ease' }}
													onClick={() => {
														navigate('../user/' + user._id);
													}}
												>
													Go back
												</button>

												{isChanged && titleErrorMsg.error === false && (
													<SaveButton
														isSaving={isSaving}
														saveFunc={() => saveTopic.mutate()}
													/>
												)}
											</div>
										</div>
									) : (
										<div className="py-6 px-3 flex flex-row justify-end">
											<button
												className="btn btn-outline btn-sm mr-1 "
												type="button"
												style={{ transition: 'all .15s ease' }}
												onClick={() => navigate('../documents')}
											>
												Go back
											</button>
											{isChanged && titleErrorMsg.error === false && (
												<SaveButton
													isSaving={isSaving}
													saveFunc={() => saveTopic.mutate()}
												/>
											)}
										</div>
									)}
								</div>
							</div>
						</div>
					</section>
				</main>
			)}
		</Scrollbars>
	);
}
